import axios from '@/axios';

export default {
    /**
   * Получить данные о менеджере
   *
   * @param {Object} vuex
   * @param {Function} vuex.commit
   * @param vuex.rootGetters
   * @param vuex.rootGetters.isAuthorized
   * @return {Promise}
   */
    fetchManager({ rootGetters: { isAuthorized }, commit }) {
        if (!isAuthorized) return Promise.resolve();

        return new Promise((resolve, reject) => {
            axios.get('cabinet/agents/help')
                .then(({ data: { data } }) => {
                    commit('SET_MANAGER', {
                        name:  data.managerName,
                        phone: data.managerPhone,
                    });
                    resolve(data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    /**
   * Обновляем комментарий
   *
   * @param {Object} vuex
   * @param {Object} vuex.rootGetters - геттеры родителя
   * @param {Object} payload
   * @param {Number} payload.type - Тип обращения
   * @param {String} payload.message - Сообщение
   * @param vuex.rootGetters.userInfo
   * @param vuex.rootGetters.userInfo.passportId
   * @return {Promise}
   */
    sendMessage({ rootGetters: { userInfo: { passportId } } }, { type, message }) {
        return new Promise((resolve, reject) => {
            axios.post('cabinet/agents/help', {
                message,
                passportId,
                type,
            })
                .then(({ data: { data } }) => {
                    resolve(data);
                })
                .catch((error) => { reject(error); });
        });
    },
};
